export function loadFromLocalStorage(key) {
  try {
    const serializedData = localStorage.getItem(key);
    if (!serializedData) return undefined;
    return JSON.parse(serializedData);
  } catch (error) {
    console.error(`Error loading ${key} from localStorage`, error);
    return undefined;
  }
}
